export default __webpack_public_path__ + "static/gallery-art-drawing-6f1de750c6f5ad032f71f19ae8436f2d.jpg";